import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Field } from "redux-form";
import { deleteCartOffers, checkCartOffer } from '../../actions/cart';
import ShopOfferItem from '../common/ShopOfferItem/ShopOfferItem.jsx';
import DeleteButton from '../common/Buttons/DeleteButton.jsx';
import Picture from '../common/ShopOfferItem/Picture.jsx';
import { minLength1 } from '../../../_utils/validators';

class CheckboxGroup extends React.Component {
  static propTypes = {
    list: PropTypes.array.isRequired,
    checkCartOffer: PropTypes.func.isRequired,
    deleteCartOffers: PropTypes.func.isRequired,
  };

  field = ({ input, list }) => {
    const { name } = input;

    const checkboxes = list.map((offer, index) => {
      const handleChange = () => { this.props.checkCartOffer(offer.id); };

      const handleDeleteClick = () => { this.props.deleteCartOffers([offer.id]); };

      const imageBlock = <>
        <Picture image={ offer.thumbnail } title={ offer.name } />
          { offer.discount > 0 && <div class='corner-ribbon corner-ribbon_size_big'>
            <span class='corner-ribbon__text corner-ribbon__text_size_big'>{ offer.discount }%</span>
          </div> }
      </>

      const checkboxBlock = <input type="checkbox"
                                           name={ `${name}[${index}]` }
                                           value={ offer.id }
                                           checked={ offer.is_checked }
                                           onChange={ handleChange } />

      const deleteButton = <DeleteButton id={ offer.id }
                        title={ gettext('Удалить из корзины') } text={ null }
                        onDeleteClick={ handleDeleteClick }/>

      return <ShopOfferItem key={ offer.id } {...offer}
                            imageBlock={ imageBlock }
                            checkboxBlock={ checkboxBlock }
                            topRightAngleMenu={ deleteButton }>
      </ShopOfferItem>
    });

    return <div>{ checkboxes }</div>;
  };

  render() {
    return <Field {...this.props} type="checkbox" validate={[minLength1]} component={ this.field } />;
  }
}

export default compose(connect(null, { deleteCartOffers, checkCartOffer }))(CheckboxGroup);